import { Component, type ReactNode } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface MyComponentState {
  hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, MyComponentState> {
  constructor(props: any) {
    super(props)

    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }
  componentDidCatch(_error: any, errorInfo: any) {
    // You can use your own error logging service here
    console.log(JSON.stringify(_error), JSON.stringify(errorInfo))
  }

  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <h2>Oops, there is an error!</h2>

          <button
            type="button"
            onClick={() => this.setState({ hasError: false })}
          >
            Try again?
          </button>
        </div>
      )
    }

    // Return children components in case of no error
    return this.props.children
  }
}

export default ErrorBoundary
